import { Select } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataUK } from './GetStartedUK';
import styles from './GetStartedUK.module.css';

export const LOAN_DURATION_OPTIONS_UK = [
  {
    label: 'A few months',
    value: '12_months',
  },
  {
    label: 'Next 1-2 years',
    value: '24_months',
  },
  {
    label: 'Next 3+ years',
    value: '36_months',
  },
  {
    label: "I'd like to dip in and out",
    value: '48_months',
  },
  {
    label: "I'm unsure at the moment",
    value: '60_months',
  },
] as const;

const LoanDurationUK = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataUK>();

  return (
    <Select
      {...register('loanDuration')}
      label="How long do you need the loan for?"
      placeholder="Please select"
      className={clsx({
        [styles.erroredSelect]: errors.loanDuration?.message,
      })}
      error={errors.loanDuration?.message}
    >
      {LOAN_DURATION_OPTIONS_UK.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default LoanDurationUK;
